




























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';


@Component({

    
})
export default class ProductDocumentationPublic extends Vue {
    @Prop({
        type: String           
    })
    public productCode: string;
    public product: any = {};
    public general: any;

    async mounted() {
        this.product = null;
        this.general = General;           
    }
    @Watch('productCode',{ immediate: true })
    async productCodeUpdate() {
        
        try{
            
            this.product = await this.getProduct();
        }catch(error){
            General.HandleError(error, this);

        }      
        
        
    }
    async getProduct(){
        if (this.productCode == null || this.productCode == '') {
            return null;
        }
        let productResponse = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/product/GetProductByCodeDocuments/' + this.productCode),
                responseType: 'json',
                withCredentials: true

        });
        return productResponse.data;
          


    }
    


   
    getDocumentsByCulture(): any[] {
        const result: any[] = [];
        const cultureMap = new Map<string, any>();
        
       
        if (!this.product || !this.product.documents) {
            return result;
        }
   
       
        this.product.documents.forEach((item: any) => {

            const cultureKey = `${item.culture.language.code}-${item.culture.country.code}`;

            if (!cultureMap.has(cultureKey)) {
                    cultureMap.set(cultureKey, {
                        culture: item.culture,
                        PDS: null,
                        SDS: null
                    });
                }
            const group = cultureMap.get(cultureKey);
            if (item.documentTypeCode === 'PDS' && !group.PDS) {
                group.PDS = item;
            } else if (item.documentTypeCode === 'SDS' && !group.SDS) {
                group.SDS = item;
            }
          
        });
        
        // Converti la mappa in un array di valori
        return Array.from(cultureMap.values());
    }

    
}
